import React from 'react';
import clsx from 'clsx';
import { DesignView, SelectProject } from '../BreadcrumbComponents/index';

// TODO fix the SelectProject tab
const DeployPageBreadcrumb = ({ selectedProject, setSelectedProject }) => {
  const changeProject = (option) => {
    let index = 0;

    JSON.parse(localStorage.getItem('data')).forEach((element, indexEl) => {
      if (element.name === option) {
        index = indexEl;
      }
    });

    localStorage.setItem('selectedProject', index);
    setSelectedProject(index);
    // setSelectedPage(-1);
  };
  return (
    <div style={{ backgroundColor: '#CFD8E0' }}>
      <div
        className={clsx('generalMarg', 'flexRowDirection')}
        style={{ justifyContent: 'space-between' }}
      >
        <div className={clsx('flexRowDirection')} style={{ width: '75%', padding: '0vw' }}>
          <SelectProject changeProject={changeProject} selectedProject={selectedProject} />
        </div>
        <div className={clsx('flexRowDirection')}>
          <DesignView selectedProject={selectedProject} />
        </div>
      </div>
    </div>
  );
};

export default DeployPageBreadcrumb;
